export default "__VITE_ASSET__789f854f__"